module.exports = __webpack_public_path__ + "img/bjdtzy_white.57c2e558.png";